import {Injectable} from '@angular/core';
import {ConfigService} from '../config/config.service';
import {TableOfContentsService} from '../toc/table-of-contents.service';
import {GoogleAnalyticsService} from '../googleAnalytics/google-analytics.service';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InitializeService {
  constructor(private config: ConfigService,
              private toc: TableOfContentsService,
              private ga: GoogleAnalyticsService) {}
              

  public async init(initStatus) {
    //console.log('***init firstRunFlag: ' + this.toc.firstRunFlag + ' theme: ' + this.config.CurrentTheme);
    //this.toc.firstRunFlag = true;
    this.config.CurrentTheme = this.toc.setupCurrentTheme(null);
   // console.log('***currentTheme in init: ' + this.config.CurrentTheme );
   /*  if (this.toc.firstRunFlag && (!this.config.CurrentTheme || this.config.CurrentTheme.length < 1)) {
      this.config.CurrentTheme = this.toc.setupCurrentTheme();
    } */
    /* if (themeName && this.config.CurrentTheme != themeName) {
      this.config.CurrentTheme === themeName;
    } */
    const currentTheme = this.config.CurrentTheme;
    //console.log('***init currenttheme: ' + currentTheme + ' tools: ' + this.config.tools.length);
    const isUserAuthorized = await this.toc.getAuthorization(this.config);

    if (isUserAuthorized) {
      //if (this.toc.firstRunFlag) {
        const themeTOCNodeFileName = this.config.themeTOCNodeFileName[currentTheme];
        if (themeTOCNodeFileName) {
          const themeData: any = await this.toc.getThemeNodeArr(themeTOCNodeFileName);
          //console.log('***init currenttheme: ' + currentTheme + ' loaded themeTOCNodeFilename');
          if (themeData) {
            this.config.tocNodeArray = themeData.nodeArr;
            if (themeData.themeQueryTasks){
              this.config.themeQueryTasks = themeData.themeQueryTasks;
            }
            if (themeData.themeLayerProperties){
              this.config.themeLayerProperties = themeData.themeLayerProperties;
            }
            this.toc.nodeArray = themeData.nodeArr;
            if (themeData.defaultVisibleLayers) {
              if (!this.config.defaultVisibleLayers) {
                this.config.defaultVisibleLayers = {};
              }
     
              this.config.defaultVisibleLayers[currentTheme] = themeData.defaultVisibleLayers;
              this.toc.showDefaultVisibleLayers();
            }
            this.config.themeNameList = themeData.themeNameList;
            // Notify observers that theme has been loaded
            this.toc.themeDataLoaded.next(true);
          } else {
            this.ga.exception('No data from: ' + themeTOCNodeFileName, true);
          }
          
        } else {
          this.ga.exception('Missing theme file for: ' + currentTheme, true);
        }
     // }
    }
    this.toc.firstRunFlag = false;
    //console.log('end init firstRunFlag: ' + this.toc.firstRunFlag);
  }

}
